<div class="dialog preset-changes-dialog">
  <h3>{{ pendingChange().type === 'progress' ? 'Progress Preset Changes' : 'Class Preset Changes' }}</h3>

  <p class="extra-info">
    @if (isRevertingCurrentPreset()) {
      Selecting this preset again will revert {{ totalChangeCount() }} setting(s)@if (userModifiedChangeCount() > 0) {, {{ userModifiedChangeCount() }} of which you customised}.
    } @else {
      Switching to this preset will change {{ totalChangeCount() }} setting(s)@if (userModifiedChangeCount() > 0) {, {{ userModifiedChangeCount() }} of which you customised}.
    }@if (pendingChange().openedAutomatically && settings.autoPreviewPresetChanges()) {
      <span class="auto-preview-disable-hint">(<a href="#" (click)="disableAutoPreview($event)">Disable seeing this dialog automatically</a>)</span>
    }
  </p>

  @if (userModifiedChangeCount() > 0) {
    <div class="dialog-toggle table-checkbox-group regular-checkbox inline"
         (click)="showOnlyUserModified.set(!showOnlyUserModified())">
      <span class="input-group-btn">
        <button type="button" class="btn toggle-btn" [class.off]="!showOnlyUserModified()"></button>
      </span>
      <span class="table-checkbox-label">Only show settings you customised</span>
    </div>
  }

  @if (pendingChange().type === 'progress') {
    <div class="preset-row">
      @for (p of progressPresets; track p.key) {
        <div class="preset-btn" [class.selected]="pendingChange().newPreset === p.key" [class.original]="pendingChange().originalPreset === p.key" (click)="setPreviewPreset(p.key)">
          <img [src]="imgPrefix + '/img/presets/' + p.img" [alt]="p.label" />
          <div class="preset-btn-label">{{ p.label }}</div>
          <div class="extra-info">Lvl {{ p.level }}</div>
        </div>
      }
    </div>
  } @else {
    <div class="preset-row class-row">
      @for (cls of classPresets(); track cls.key) {
        <div class="preset-btn" [class.selected]="pendingChange().newPreset === cls.key" [class.original]="pendingChange().originalPreset === cls.key" (click)="setPreviewPreset(cls.key)">
          <img [src]="cls.img" [alt]="cls.key" />
          <div class="preset-btn-label">{{ cls.key }}</div>
        </div>
      }
    </div>
  }

  <div class="changes-list poe-scrollbar">
    @for (group of changesBySection(); track group.label) {
      <div class="changes-section">
        <div class="changes-section-title">{{ group.label }}</div>
        @for (change of group.changes; track change.key) {
          <div class="change-row regular-checkbox inline" [class.user-modified]="change.isUserModified">
            <div class="change-content">
              <span class="change-label">
                {{ change.label }}
                @if (change.isUserModified) {
                  <span class="icon icon-warning" title="This setting was customised by you"></span>
                }
              </span>
              @if (change.arrayDiffItems) {
                <span class="change-values change-array-values">
                  @for (item of change.arrayDiffItems; track $index) {
                    <span class="array-item"
                          [class.array-item-unchanged]="item.status === 'unchanged'"
                          [class.array-item-removed]="item.status === 'removed'"
                          [class.array-item-added]="item.status === 'added'">{{ item.text }}</span>
                  }
                </span>
              } @else {
                <span class="change-values">
                  <span class="change-old">{{ change.formattedCurrentValue }}</span>
                  <span class="change-arrow">→</span>
                  <span class="change-new">{{ change.formattedNewValue }}</span>
                </span>

                @if (change.tieringCutoffHint) {
                  <app-tiering-cutoff-hint [hint]="change.tieringCutoffHint" />
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="dialog-controls">
    <button class="btn dialog-btn dialog-main-btn" (click)="onConfirm()">Apply</button>
    <button class="btn dialog-btn dialog-cancel-btn" (click)="onCancel()">Cancel</button>
  </div>
</div>
